import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    cmsConfig: {
      urls: {
        api: string,
        auth: string,
        community: string,
        config: string,
        content: string,
        game: string,
        home: string,
        sync: string,
        organization: string
      }
      secrets: {
        clientId: string,
        clientSecret: string
      },
      realm: string
    };
  }
}

const authConfig = {
  clientId: environment.clientId ? environment.clientId : window.cmsConfig.secrets.clientId,
  clientSecret: environment.clientSecret ? environment.clientSecret : window.cmsConfig.secrets.clientSecret,
  realm: environment.realm ? environment.realm : window.cmsConfig.realm,
  ncChannelHeader: 'cms'
};

const userConfig = {
  username: 'pwa',
  password: '',
  redirectUrl: undefined,
  secret: environment.clientSecret ? environment.clientSecret : window.cmsConfig.secrets.clientSecret
};

export const cmsConfig = {
  apiUrl: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.api,
  authUrl: environment.authUrl ? environment.authUrl : window.cmsConfig.urls.auth,
  communityUrl: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.community,
  configUrl: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.config,
  contentUrl: environment.contentUrl ? environment.contentUrl : window.cmsConfig.urls.content,
  gameUrl: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.game,
  homeUrl: environment.homeUrl ? environment.homeUrl : window.cmsConfig.urls.home,
  auth: authConfig,
  user: userConfig,
  expireThreshold: 1000 * 60 * 5, // 5 minutes
  sync: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.sync,
  organization: environment.baseUrl ? environment.baseUrl : window.cmsConfig.urls.organization,
};
